import { BookingActionTypes } from "./actionTypes";


const initialState = {
    bookingListError: null,
    loadingBookings: false,
    message: null,
    isLoadingAddBooking: false,
    isAddNewBookingOpen: false,
    // Add query parameters to the state to act as a single source of truth.
    query: {
        page: 1, pageSize: 20, bookingsType: 'paid', search: {text: '', filter: '', tagsFilters: {}, searchInArchive: false}
    }
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case BookingActionTypes.BOOKING_LIST_GET:
            state = {
                ...state,
                bookingList: null,
                loadingBookings: true,
                bookingListError: null
            }
            break;
        case BookingActionTypes.BOOKING_LIST_GET_SUCCESSFUL:
            state = {
                ...state,
                bookingList: action.payload,
                loadingBookings: false,
                bookingListError: null
            }
            break;
        case BookingActionTypes.BOOKING_LIST_GET_ERROR:
            state = {
                ...state,
                bookingList: null,
                loadingBookings: false,
                bookingListError: action.payload
            }
            break;
        // This new case will handle updating the stored query.
        case BookingActionTypes.SET_BOOKING_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case BookingActionTypes.RESET_BOOKING_QUERY:
            state = {
                ...state,
                query: initialState.query
            }
            break;
        case BookingActionTypes.BOOKING_ADD_MODAL:
            state = {
                ...state,
                isAddNewBookingOpen: action.payload,
            }
            break;
        case BookingActionTypes.BOOKING_ADD_MODAL_SUCCESS:
            state = {
                ...state,
                isAddNewBookingOpen: action.payload,
            }
            break;
        case BookingActionTypes.BOOKING_ADD:
            state = {
                ...state,
                isLoadingAddBooking: true
            }
            break;
        case BookingActionTypes.BOOKING_ADD_SUCCESSFUL:
            state = {
                ...state,
                isLoadingAddBooking: false,
                isAddNewBookingOpen: false,
            }
            break;
        case BookingActionTypes.BOOKING_ADD_ERROR:
            state = {
                ...state,
                isLoadingAddBooking: false,
                isAddNewBookingOpen: false,
            }
            break;
        case BookingActionTypes.BOOKING_REMOVE_SUCCESS:
            state = {
                ...state,
                isLoadingAddBooking: false,
                isAddNewBookingOpen: false,
            }
            break;
        case BookingActionTypes.BOOKING_REMOVE_ERROR:
            state = {
                ...state,
                isLoadingAddBooking: false,
                isAddNewBookingOpen: false,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default account;